// Imports
import { GetRegionsResponse } from '../../types/api/main/regions/get';


// Mock regions for storybook
const storybookRegions: GetRegionsResponse = [
	{
		code: 'AUS',
		twoLetterCode: 'AU',
		name: 'Australia',
		regionChoiceLabel: 'State / territory',
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			'External Territories': [
				{ id: 115, name: 'Christmas Island' },
				{ id: 116, name: 'Cocos (Keeling) Islands' },
				{ id: 114, name: 'Norfolk Island' },
			],
			States: [
				{ id: 105, name: 'New South Wales' },
				{ id: 106, name: 'Queensland' },
				{ id: 107, name: 'South Australia' },
				{ id: 108, name: 'Tasmania' },
				{ id: 109, name: 'Victoria' },
				{ id: 110, name: 'Western Australia' },
			],
			Territories: [
				{ id: 111, name: 'Australian Capital Territory' },
				{ id: 112, name: 'Jervis Bay Territory' },
				{ id: 113, name: 'Northern Territory' },
			],
		},
	},
	{
		code: 'BHS',
		twoLetterCode: 'BS',
		name: 'Bahamas',
		regionChoiceLabel: 'Island',
		nameForPostalCode: null,
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Islands: [
				{ id: 117, name: 'Acklins' },
				{ id: 118, name: 'Berry Islands' },
				{ id: 119, name: 'Bimini' },
				{ id: 120, name: 'Black Point' },
				{ id: 121, name: 'Cat Island' },
				{ id: 122, name: 'Central Abaco' },
				{ id: 123, name: 'Central Andros' },
				{ id: 124, name: 'Central Eleuthera' },
				{ id: 125, name: 'City of Freeport' },
				{ id: 126, name: 'Crooked Island' },
				{ id: 127, name: 'East Grand Bahama' },
				{ id: 128, name: 'Exuma' },
				{ id: 129, name: 'Grand Cay' },
				{ id: 130, name: 'Green Turtle Cay' },
				{ id: 131, name: 'Harbour Island' },
				{ id: 132, name: 'Hope Town' },
				{ id: 133, name: 'Inagua' },
				{ id: 134, name: 'Long Island' },
				{ id: 135, name: 'Mangrove Cay' },
				{ id: 136, name: 'Mayaguana' },
				{ id: 137, name: "Moore's Island" },
				{ id: 138, name: 'New Providence' },
				{ id: 139, name: 'North Abaco' },
				{ id: 140, name: 'North Andros' },
				{ id: 141, name: 'North Eleuthera' },
				{ id: 142, name: 'Ragged Island' },
				{ id: 143, name: 'Rum Cay' },
				{ id: 144, name: 'San Salvador' },
				{ id: 145, name: 'South Abaco' },
				{ id: 146, name: 'South Andros' },
				{ id: 147, name: 'South Eleuthera' },
				{ id: 148, name: 'Spanish Wells' },
				{ id: 149, name: 'West Grand Bahama' },
			],
		},
	},
	{
		code: 'CAN',
		twoLetterCode: 'CA',
		name: 'Canada',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 60, name: 'Alberta' },
				{ id: 61, name: 'British Columbia' },
				{ id: 62, name: 'Manitoba' },
				{ id: 63, name: 'New Brunswick' },
				{ id: 64, name: 'Newfoundland and Labrador' },
				{ id: 66, name: 'Northwest Territories' },
				{ id: 65, name: 'Nova Scotia' },
				{ id: 67, name: 'Nunavut' },
				{ id: 68, name: 'Ontario' },
				{ id: 69, name: 'Prince Edward Island' },
				{ id: 70, name: 'Quebec' },
				{ id: 71, name: 'Saskatchewan' },
				{ id: 72, name: 'Yukon' },
			],
		},
	},
	{
		code: 'CRI',
		twoLetterCode: 'CR',
		name: 'Costa Rica',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': 'Canton' },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 150, name: 'Alajuela' },
				{ id: 151, name: 'Cartago' },
				{ id: 152, name: 'Guanacaste' },
				{ id: 153, name: 'Heredia' },
				{ id: 154, name: 'Limón' },
				{ id: 155, name: 'Puntarenas' },
				{ id: 156, name: 'San José' },
			],
		},
	},
	{
		code: 'CUW',
		twoLetterCode: 'CW',
		name: 'Curaçao',
		regionChoiceLabel: null,
		nameForPostalCode: null,
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'DOM',
		twoLetterCode: 'DO',
		name: 'Dominican Republic',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 157, name: 'Azua' },
				{ id: 158, name: 'Baoruco' },
				{ id: 159, name: 'Barahona' },
				{ id: 160, name: 'Dajabón' },
				{ id: 161, name: 'Distrito Nacional' },
				{ id: 162, name: 'Duarte' },
				{ id: 163, name: 'El Seibo' },
				{ id: 164, name: 'Elías Piña' },
				{ id: 165, name: 'Espaillat' },
				{ id: 166, name: 'Hato Mayor' },
				{ id: 167, name: 'Hermanas Mirabal' },
				{ id: 168, name: 'Independencia' },
				{ id: 169, name: 'La Altagracia' },
				{ id: 170, name: 'La Romana' },
				{ id: 171, name: 'La Vega' },
				{ id: 172, name: 'María Trinidad Sánchez' },
				{ id: 173, name: 'Monseñor Nouel' },
				{ id: 174, name: 'Monte Cristi' },
				{ id: 175, name: 'Monte Plata' },
				{ id: 176, name: 'Pedernales' },
				{ id: 177, name: 'Peravia' },
				{ id: 178, name: 'Puerto Plata' },
				{ id: 179, name: 'Samaná' },
				{ id: 180, name: 'San Cristóbal' },
				{ id: 181, name: 'San José de Ocoa' },
				{ id: 182, name: 'San Juan' },
				{ id: 183, name: 'San Pedro de Macorís' },
				{ id: 184, name: 'Sánchez Ramírez' },
				{ id: 185, name: 'Santiago' },
				{ id: 186, name: 'Santiago Rodríguez' },
				{ id: 187, name: 'Santo Domingo' },
				{ id: 188, name: 'Valverde' },
			],
		},
	},
	{
		code: 'DEU',
		twoLetterCode: 'DE',
		name: 'Germany',
		regionChoiceLabel: null,
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'HND',
		twoLetterCode: 'HN',
		name: 'Honduras',
		regionChoiceLabel: 'Department',
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': 'District' },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Departments: [
				{ id: 189, name: 'Atlántida' },
				{ id: 190, name: 'Choluteca' },
				{ id: 191, name: 'Colón' },
				{ id: 192, name: 'Comayagua' },
				{ id: 193, name: 'Copán' },
				{ id: 194, name: 'Cortés' },
				{ id: 195, name: 'El Paraíso' },
				{ id: 196, name: 'Francisco Morazán' },
				{ id: 197, name: 'Gracias a Dios' },
				{ id: 198, name: 'Intibucá' },
				{ id: 199, name: 'Islas de la Bahía' },
				{ id: 200, name: 'La Paz' },
				{ id: 201, name: 'Lempira' },
				{ id: 202, name: 'Ocotepeque' },
				{ id: 203, name: 'Olancho' },
				{ id: 204, name: 'Santa Bárbara' },
				{ id: 205, name: 'Valle' },
				{ id: 206, name: 'Yoro' },
			],
		},
	},
	{
		code: 'JAM',
		twoLetterCode: 'JM',
		name: 'Jamaica',
		regionChoiceLabel: 'Parish',
		nameForPostalCode: null,
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Parishes: [
				{ id: 207, name: 'Clarendon' },
				{ id: 208, name: 'Hanover' },
				{ id: 209, name: 'Kingston' },
				{ id: 210, name: 'Manchester' },
				{ id: 211, name: 'Portland' },
				{ id: 212, name: 'Saint Andrew' },
				{ id: 213, name: 'Saint Ann' },
				{ id: 214, name: 'Saint Catherine' },
				{ id: 215, name: 'Saint Elizabeth' },
				{ id: 216, name: 'Saint James' },
				{ id: 217, name: 'Saint Mary' },
				{ id: 218, name: 'Saint Thomas' },
				{ id: 219, name: 'Trelawny' },
				{ id: 220, name: 'Westmoreland' },
			],
		},
	},
	{
		code: 'MUS',
		twoLetterCode: 'MU',
		name: 'Mauritius',
		regionChoiceLabel: null,
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'Town', '2': 'Sub-locality' },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'MEX',
		twoLetterCode: 'MX',
		name: 'Mexico',
		regionChoiceLabel: 'State',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': 'Colonia' },
		divisionPrefixes: { '1': null, '2': 'Col.' },
		regions: {
			States: [
				{ id: 73, name: 'Aguascalientes' },
				{ id: 74, name: 'Baja California' },
				{ id: 75, name: 'Baja California Sur' },
				{ id: 76, name: 'Campeche' },
				{ id: 77, name: 'Chiapas' },
				{ id: 78, name: 'Chihuahua' },
				{ id: 79, name: 'Ciudad de México' },
				{ id: 80, name: 'Coahuila' },
				{ id: 81, name: 'Colima' },
				{ id: 82, name: 'Durango' },
				{ id: 83, name: 'Estado de México' },
				{ id: 84, name: 'Guanajuato' },
				{ id: 85, name: 'Guerrero' },
				{ id: 86, name: 'Hidalgo' },
				{ id: 87, name: 'Jalisco' },
				{ id: 88, name: 'Michoacán' },
				{ id: 89, name: 'Morelos' },
				{ id: 90, name: 'Nayarit' },
				{ id: 91, name: 'Nuevo León' },
				{ id: 92, name: 'Oaxaca' },
				{ id: 93, name: 'Puebla' },
				{ id: 94, name: 'Querétaro' },
				{ id: 95, name: 'Quintana Roo' },
				{ id: 96, name: 'San Luis Potosí' },
				{ id: 97, name: 'Sinaloa' },
				{ id: 98, name: 'Sonora' },
				{ id: 99, name: 'Tabasco' },
				{ id: 100, name: 'Tamaulipas' },
				{ id: 101, name: 'Tlaxcala' },
				{ id: 102, name: 'Veracruz' },
				{ id: 103, name: 'Yucatán' },
				{ id: 104, name: 'Zacatecas' },
			],
		},
	},
	{
		code: 'NZL',
		twoLetterCode: 'NZ',
		name: 'New Zealand',
		regionChoiceLabel: null,
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'NIC',
		twoLetterCode: 'NI',
		name: 'Nicaragua',
		regionChoiceLabel: 'Department',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Departments: [
				{ id: 371, name: 'Boaco' },
				{ id: 372, name: 'Carazo' },
				{ id: 373, name: 'Chinandega' },
				{ id: 374, name: 'Chontales' },
				{ id: 375, name: 'Estelí' },
				{ id: 376, name: 'Granada' },
				{ id: 377, name: 'Jinotega' },
				{ id: 378, name: 'León' },
				{ id: 379, name: 'Madriz' },
				{ id: 380, name: 'Managua' },
				{ id: 381, name: 'Masaya' },
				{ id: 382, name: 'Matagalpa' },
				{ id: 383, name: 'Nueva Segovia' },
				{ id: 384, name: 'Raan' },
				{ id: 385, name: 'Raas' },
				{ id: 386, name: 'Rio San Juan' },
				{ id: 387, name: 'Rivas' },
			],
		},
	},
	{
		code: 'PAN',
		twoLetterCode: 'PA',
		name: 'Panama',
		regionChoiceLabel: 'Province',
		nameForPostalCode: null,
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 221, name: 'Bocas del Toro' },
				{ id: 222, name: 'Chiriquí' },
				{ id: 223, name: 'Coclé' },
				{ id: 224, name: 'Colón' },
				{ id: 225, name: 'Darién' },
				{ id: 226, name: 'Emberá' },
				{ id: 227, name: 'Guna Yala' },
				{ id: 228, name: 'Herrera' },
				{ id: 229, name: 'Los Santos' },
				{ id: 230, name: 'Ngäbe-Buglé' },
				{ id: 231, name: 'Panamá' },
				{ id: 233, name: 'Panamá Oeste' },
				{ id: 232, name: 'Veraguas' },
			],
		},
	},
	{
		code: 'SGP',
		twoLetterCode: 'SG',
		name: 'Singapore',
		regionChoiceLabel: null,
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'Town', '2': null },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'ZAF',
		twoLetterCode: 'ZA',
		name: 'South Africa',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 234, name: 'Eastern Cape' },
				{ id: 235, name: 'Free State' },
				{ id: 236, name: 'Gauteng' },
				{ id: 237, name: 'KwaZulu-Natal' },
				{ id: 238, name: 'Limpopo' },
				{ id: 239, name: 'Mpumalanga' },
				{ id: 240, name: 'North West' },
				{ id: 241, name: 'Northern Cape' },
				{ id: 242, name: 'Western Cape' },
			],
		},
	},
	{
		code: 'ESP',
		twoLetterCode: 'ES',
		name: 'Spain',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 243, name: 'A Coruña' },
				{ id: 244, name: 'Álava' },
				{ id: 245, name: 'Albacete' },
				{ id: 246, name: 'Alicante' },
				{ id: 247, name: 'Almería' },
				{ id: 248, name: 'Asturias' },
				{ id: 249, name: 'Ávila' },
				{ id: 250, name: 'Badajoz' },
				{ id: 251, name: 'Balearic Islands' },
				{ id: 252, name: 'Barcelona' },
				{ id: 253, name: 'Biscay' },
				{ id: 254, name: 'Burgos' },
				{ id: 255, name: 'Cáceres' },
				{ id: 256, name: 'Cádiz' },
				{ id: 257, name: 'Cantabria' },
				{ id: 258, name: 'Castellón' },
				{ id: 259, name: 'Ceuta' },
				{ id: 260, name: 'Ciudad Real' },
				{ id: 261, name: 'Córdoba' },
				{ id: 262, name: 'Cuenca' },
				{ id: 263, name: 'Gipuzkoa' },
				{ id: 264, name: 'Girona' },
				{ id: 265, name: 'Granada' },
				{ id: 266, name: 'Guadalajara' },
				{ id: 267, name: 'Huelva' },
				{ id: 268, name: 'Huesca' },
				{ id: 269, name: 'Jaén' },
				{ id: 270, name: 'La Rioja' },
				{ id: 271, name: 'Las Palmas' },
				{ id: 272, name: 'León' },
				{ id: 273, name: 'Lleida' },
				{ id: 274, name: 'Lugo' },
				{ id: 275, name: 'Madrid' },
				{ id: 276, name: 'Málaga' },
				{ id: 277, name: 'Melilla' },
				{ id: 278, name: 'Murcia' },
				{ id: 279, name: 'Navarre' },
				{ id: 280, name: 'Ourense' },
				{ id: 281, name: 'Palencia' },
				{ id: 282, name: 'Pontevedra' },
				{ id: 283, name: 'Salamanca' },
				{ id: 284, name: 'Santa Cruz de Tenerife' },
				{ id: 285, name: 'Segovia' },
				{ id: 286, name: 'Seville' },
				{ id: 287, name: 'Soria' },
				{ id: 288, name: 'Tarragona' },
				{ id: 289, name: 'Teruel' },
				{ id: 290, name: 'Toledo' },
				{ id: 291, name: 'Valencia' },
				{ id: 292, name: 'Valladolid' },
				{ id: 293, name: 'Zamora' },
				{ id: 294, name: 'Zaragoza' },
			],
		},
	},
	{
		code: 'THA',
		twoLetterCode: 'TH',
		name: 'Thailand',
		regionChoiceLabel: 'Province',
		nameForPostalCode: 'Postal code',
		divisionNames: { '1': 'District', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			Provinces: [
				{ id: 295, name: 'Amnat Charoen' },
				{ id: 296, name: 'Ang Thong' },
				{ id: 297, name: 'Buriram' },
				{ id: 298, name: 'Chachoengsao' },
				{ id: 299, name: 'Chai Nat' },
				{ id: 300, name: 'Chaiyaphum' },
				{ id: 301, name: 'Chanthaburi' },
				{ id: 302, name: 'Chiang Mai' },
				{ id: 303, name: 'Chiang Rai' },
				{ id: 304, name: 'Chon Buri' },
				{ id: 305, name: 'Chumphon' },
				{ id: 306, name: 'Kalasin' },
				{ id: 307, name: 'Kamphaeng Phet' },
				{ id: 308, name: 'Kanchanaburi' },
				{ id: 309, name: 'Khon Kaen' },
				{ id: 310, name: 'Krabi' },
				{ id: 311, name: 'Krung Thep Mahanakhon' },
				{ id: 312, name: 'Lampang' },
				{ id: 313, name: 'Lamphun' },
				{ id: 314, name: 'Loei' },
				{ id: 315, name: 'Lop Buri' },
				{ id: 316, name: 'Mae Hong Son' },
				{ id: 317, name: 'Maha Sarakham' },
				{ id: 318, name: 'Mukdahan' },
				{ id: 319, name: 'Nakhon Nayok' },
				{ id: 320, name: 'Nakhon Pathom' },
				{ id: 321, name: 'Nakhon Phanom' },
				{ id: 322, name: 'Nakhon Ratchasima' },
				{ id: 323, name: 'Nakhon Sawan' },
				{ id: 324, name: 'Nakhon Si Thammarat' },
				{ id: 325, name: 'Nan' },
				{ id: 326, name: 'Narathiwat' },
				{ id: 327, name: 'Nong Bua Lamphu' },
				{ id: 328, name: 'Nong Khai' },
				{ id: 329, name: 'Nonthaburi' },
				{ id: 330, name: 'Pathum Thani' },
				{ id: 331, name: 'Pattani' },
				{ id: 332, name: 'Phang Nga' },
				{ id: 333, name: 'Phatthalung' },
				{ id: 334, name: 'Phayao' },
				{ id: 335, name: 'Phetchabun' },
				{ id: 336, name: 'Phetchaburi' },
				{ id: 337, name: 'Phichit' },
				{ id: 338, name: 'Phitsanulok' },
				{ id: 339, name: 'Phra Nakhon Si Ayutthaya' },
				{ id: 340, name: 'Phrae' },
				{ id: 341, name: 'Phuket' },
				{ id: 342, name: 'Prachin Buri' },
				{ id: 343, name: 'Prachuap Khiri Khan' },
				{ id: 344, name: 'Ranong' },
				{ id: 345, name: 'Ratchaburi' },
				{ id: 346, name: 'Rayong' },
				{ id: 347, name: 'Roi Et' },
				{ id: 348, name: 'Sa Kaeo' },
				{ id: 349, name: 'Sakon Nakhon' },
				{ id: 350, name: 'Samut Prakan' },
				{ id: 351, name: 'Samut Sakhon' },
				{ id: 352, name: 'Samut Songkhram' },
				{ id: 353, name: 'Sara Buri' },
				{ id: 354, name: 'Satun' },
				{ id: 355, name: 'Sing Buri' },
				{ id: 356, name: 'Sisaket' },
				{ id: 357, name: 'Songkhla' },
				{ id: 358, name: 'Sukhothai' },
				{ id: 359, name: 'Suphan Buri' },
				{ id: 360, name: 'Surat Thani' },
				{ id: 361, name: 'Surin' },
				{ id: 362, name: 'Tak' },
				{ id: 363, name: 'Trang' },
				{ id: 364, name: 'Trat' },
				{ id: 365, name: 'Ubon Ratchathani' },
				{ id: 366, name: 'Udon Thani' },
				{ id: 367, name: 'Uthai Thani' },
				{ id: 368, name: 'Uttaradit' },
				{ id: 369, name: 'Yala' },
				{ id: 370, name: 'Yasothon' },
			],
		},
	},
	{
		code: 'GBR',
		twoLetterCode: 'GB',
		name: 'United Kingdom',
		regionChoiceLabel: null,
		nameForPostalCode: 'Postcode',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
	},
	{
		code: 'USA',
		twoLetterCode: 'US',
		name: 'United States',
		regionChoiceLabel: 'State / territory',
		nameForPostalCode: 'ZIP code',
		divisionNames: { '1': 'City', '2': null },
		divisionPrefixes: { '1': null, '2': null },
		regions: {
			States: [
				{ id: 1, name: 'Alabama' },
				{ id: 2, name: 'Alaska' },
				{ id: 3, name: 'Arizona' },
				{ id: 4, name: 'Arkansas' },
				{ id: 5, name: 'California' },
				{ id: 6, name: 'Colorado' },
				{ id: 7, name: 'Connecticut' },
				{ id: 8, name: 'Delaware' },
				{ id: 9, name: 'Florida' },
				{ id: 10, name: 'Georgia' },
				{ id: 11, name: 'Hawaii' },
				{ id: 12, name: 'Idaho' },
				{ id: 13, name: 'Illinois' },
				{ id: 14, name: 'Indiana' },
				{ id: 15, name: 'Iowa' },
				{ id: 16, name: 'Kansas' },
				{ id: 17, name: 'Kentucky' },
				{ id: 18, name: 'Louisiana' },
				{ id: 19, name: 'Maine' },
				{ id: 20, name: 'Maryland' },
				{ id: 21, name: 'Massachusetts' },
				{ id: 22, name: 'Michigan' },
				{ id: 23, name: 'Minnesota' },
				{ id: 24, name: 'Mississippi' },
				{ id: 25, name: 'Missouri' },
				{ id: 26, name: 'Montana' },
				{ id: 27, name: 'Nebraska' },
				{ id: 28, name: 'Nevada' },
				{ id: 29, name: 'New Hampshire' },
				{ id: 30, name: 'New Jersey' },
				{ id: 31, name: 'New Mexico' },
				{ id: 32, name: 'New York' },
				{ id: 33, name: 'North Carolina' },
				{ id: 34, name: 'North Dakota' },
				{ id: 35, name: 'Ohio' },
				{ id: 36, name: 'Oklahoma' },
				{ id: 37, name: 'Oregon' },
				{ id: 38, name: 'Pennsylvania' },
				{ id: 39, name: 'Rhode Island' },
				{ id: 40, name: 'South Carolina' },
				{ id: 41, name: 'South Dakota' },
				{ id: 42, name: 'Tennessee' },
				{ id: 43, name: 'Texas' },
				{ id: 44, name: 'Utah' },
				{ id: 45, name: 'Vermont' },
				{ id: 46, name: 'Virginia' },
				{ id: 47, name: 'Washington' },
				{ id: 48, name: 'Washington, D.C.' },
				{ id: 49, name: 'West Virginia' },
				{ id: 50, name: 'Wisconsin' },
				{ id: 51, name: 'Wyoming' },
			],
			Territories: [
				{ id: 52, name: 'American Samoa' },
				{ id: 53, name: 'Federated States of Micronesia' },
				{ id: 54, name: 'Guam' },
				{ id: 55, name: 'Marshall Islands' },
				{ id: 56, name: 'Northern Mariana Islands' },
				{ id: 57, name: 'Palau' },
				{ id: 58, name: 'Puerto Rico' },
				{ id: 59, name: 'Virgin Islands' },
			],
		},
	},
];

export default storybookRegions;
